// Libraries
import React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { useTranslation } from "react-i18next"
// Icons
import Location from "@Icons/Location"
import Email from "@Icons/Email"
import Phone from "@Icons/Phone"
import Facebook from "@Icons/social/Facebook"
import LinkedIn from "@Icons/social/LinkedIn"
// Components
import Container from "@Components/Container/Container"
// Types
import { Tag } from "@Types/tags"
// Styles
import * as styles from "./Footer.module.scss"
import Button, { ButtonTag, ButtonVariant } from "@Components/Button/Button"
import classNames from "classnames"

const Footer = () => {
  const { t, i18n } = useTranslation()

  return (
    <Container as={Tag.Footer} classes={styles.wrapper}>
      <div className={styles.links}>
        <div className={styles.linksItemLarge}>
          <Link to="/" className={styles.logo}>
            <StaticImage
              src="../../../../assets/images/logo.png"
              alt="Neuroclinikmed"
              loading="lazy"
              placeholder="blurred"
              formats={["auto", "webp"]}
              objectFit="contain"
              height={64}
            />
          </Link>
          <a
            href="https://g.co/kgs/53FExyK"
            target="_blank"
            rel="noopener"
            className={styles.itemWithSvg}
          >
            <Location />
            <span>
              Ul. Nowowiejskiego 25/11
              <br />
              61-129 Poznań
              <br />
              <br />
              NIP: 7822257734 <br />
              REGON: 525673439
            </span>
          </a>
        </div>

        <div className={classNames(styles.linksItem, styles.contact)}>
          <h4 className={styles.title}>{t("footer.contact")}</h4>
          <a className={styles.itemWithSvg} href="tel:+48572573737">
            <Phone /> <span>+48 572 573 737</span>
          </a>
          <a className={styles.itemWithSvg} href="mailto:">
            <Email /> <span>recepcja@neuroklinikmed.com</span>
          </a>
        </div>
        <div className={styles.linksItem}>
          <h4 className={styles.title}>{t("footer.social")}</h4>
          <div className={styles.social}>
            <a
              className={styles.text}
              href="https://www.facebook.com/profile.php?id=61569280031320"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Facebook />
            </a>
          </div>
        </div>
      </div>

      <p className={styles.bottom}>
        <small>Copyright &copy; 2024 All rights reserved</small>
        <br />
        <small>
          Designed & made by:{" "}
          <a
            href="https://www.innovate-ts.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            ITS
          </a>
        </small>
      </p>
    </Container>
  )
}

export default Footer
